

import blogCategories from '@/apollo/queries/blog/blogCategories'
import blogAuthors from '@/apollo/queries/blog/blogAuthors'

export default {
  name: 'BlogFilterMobileMenu',
  props: {
    filterMenuActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeItem: "",
      blogCategories: [],
      blogAuthors: [],
      isFilterMenuActive: true
    }
  },
  computed: {
    activeType() {
      return this.$store.state.blog.filters.activeType
    },
    blogCategoriesComputed() {
      const uniqueIds = [];

      if(this.blogCategories) {
        const unique = this.blogCategories.filter(element => {
          const isDuplicate = uniqueIds.includes(element?.DisplayName);
          if (!isDuplicate) {
            uniqueIds.push(element?.DisplayName);
            return true;
          }
          return false;
        });
        return unique
      }
      return []
    }
  },
  watch: {
    filterMenuActive(newValue, oldValue) {
      if(newValue !== oldValue) {
        this.isFilterMenuActive = newValue
        console.debug('watch filterMenuActive:', newValue, oldValue)
      }
    }
  },
  methods: {
    setActive() {
      this.isFilterMenuActive = true 
      console.debug('isFilterMenuActive1.......',this.isFilterMenuActive)
      this.$emit('update:filterMenuActive', true);
    },
    toggleActive() {
      this.isFilterMenuActive = !this.isFilterMenuActive 
      console.debug('isFilterMenuActive2.......',this.isFilterMenuActive)
      this.$emit('update:filterMenuActive', this.isFilterMenuActive);
    },
    setInactive() {
      this.isFilterMenuActive = false
      console.debug('isFilterMenuActive3.......',this.isFilterMenuActive)
      this.$emit('update:filterMenuActive', false);
    },
    confirmFilter() {
      console.debug('confirmFilter....isFilterMenuActive...',this.isFilterMenuActive)
      this.isFilterMenuActive = false
      console.debug('confirmFilter....isFilterMenuActive...',this.isFilterMenuActive)
      this.$emit('update:filterMenuActive', false);
    },
    hideMenu() {
      this.$store.commit('blog/setMobileMenuState', false)
    }
  },
  apollo: {
      blogCategories: {
          prefetch: true,
          query: blogCategories,
          variables() {
              return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
          },
          update(data) {
              return this.$normalizeStrapi(data.blogCategories.data);
          },
          result({ data }) {
              // console.debug("***apollo blogCategories data ***");
              // console.debug(JSON.stringify(data));
          }
      },
      blogAuthors: {
          prefetch: true,
          query: blogAuthors,
          variables() {
              return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
          },
          update(data) {
              return this.$normalizeStrapi(data.blogAuthors.data);
          },
          result({ data }) {
              // console.debug("***apollo blogAuthors data ***");
              // console.debug(JSON.stringify(data));
          },
      },
    },
  }
